import { getUserLocation } from './common'
import { USER_GEO_IP_LOCATION_KEY } from 'constants/common'
import { blackListedRoutesForPageView } from 'constants/common'

const logPageView = (pageName = '', data = {}): void => {
  if (
    globalThis.rudderanalytics &&
    !blackListedRoutesForPageView.includes(pageName)
  ) {
    const userLocation = getUserLocation()

    globalThis.rudderanalytics.page(pageName, data, {
      ...(userLocation && {
        location: {
          [USER_GEO_IP_LOCATION_KEY]: userLocation,
        },
      }),
    })
  }
}

export default logPageView
